import * as React from 'react';
import TypeSeedHeader from './components/TypeSeedHeader';
import TypeSeedGraphics from './components/TypeSeedGraphics';
import TypeSeedBullets from './components/TypeSeedBullets';
import { ISeedProduct, IDocument } from '../../infrastructure/interfaces';
import { SeedCategory } from 'src/infrastructure/enums';
import './styles/TypeSeed.css';

export interface ITypeSeed {
  product: ISeedProduct;
  pageNumber?: number;
  document?: IDocument;
}

export default class TypeSeed extends React.Component<ITypeSeed> {

  constructor(props: ITypeSeed) {
    super(props);
  }

  componentDidMount() {
  }

  componentWillReceiveProps() {
  }

  render() {
    const {
      category: {
        id: categoryId,
      },
    } = this.props.product;

    const classNames = [
      'page-drop',
      'seed',
      `seed-category-${categoryId}`,
    ];

    const showBarChart = !(
      (categoryId === SeedCategory.Cotton)
      || (categoryId === SeedCategory.Rice)
      || (categoryId === SeedCategory.Mustard)
      || (categoryId === SeedCategory.Barley)
      || (categoryId === SeedCategory.DurumWheat)
      || (categoryId === SeedCategory.Flax)
    );


    return (
      <div className={classNames.join(' ')}>
        <div className="drop-content">
          <TypeSeedHeader product={this.props.product} document={this.props.document}></TypeSeedHeader>
          {!showBarChart && <TypeSeedBullets product={this.props.product}></TypeSeedBullets>}
          <TypeSeedGraphics product={this.props.product} document={this.props.document}></TypeSeedGraphics>
          {showBarChart && <TypeSeedBullets product={this.props.product}></TypeSeedBullets>}
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Products/TypeSeed.tsx